/*
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import { useEffect, useRef } from "react";
export { useFetchMany, useFetchPaginated } from "./useFetchMany";
export { useFetchOne } from "./useFetchOne";
export { useDeferredEffects } from "./useDeferredEffects";
export { useInitialPaginationFetch } from "./useInitialPaginationFetch";
export { DOC_PATHS, useDocUrl } from "./useDocUrl";
export type { DocPath } from "./useDocUrl";

export function useDomWatcher(
  callback: Function,
  skip?: boolean,
  targetSelector?: string
): React.RefObject<any> {
  const ref: React.RefObject<any> = useRef();

  useEffect(() => {
    if (skip) {
      return;
    }

    const handleClickOutside = (event) => {
      if (
        (ref.current && !ref.current.contains(event.target)) ||
        (targetSelector && !event.target.closest(targetSelector))
      ) {
        callback && callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [skip]);

  return ref;
}
